<template>
    <FormRegistro :p_item_cliente="item_cliente" @saveParent="save" :p_fields_errors="fields_errors"
    :p_sucursal="current_sucursal" @isClear="clear" />
    <div class="d-flex flex-wrap">

    <v-btn color="green-darken-1" variant="outlined" class="ma-1" @click="openDialogImportData">
      <v-icon icon="mdi-file-excel" />&nbsp;Importar
    </v-btn>
  </div>
  <v-dialog v-model="dialog_import" persistent transition="dialog-bottom-transition" 
    scrollable  width="600px" max-height="600px">
    <DialogImportPersonalPolicial :p_current_sucursal="current_sucursal" @isCloseDialogImportData="closeDialogImportData"
      @isInitData="initData" />
  </v-dialog>
</template>

<script>
import { defineComponent } from 'vue';
import FormRegistro from '@/components/registro/FormRegistro.vue';
import DialogImportPersonalPolicial from '@/components/registro/DialogImportPersonalPolicial.vue';
export default defineComponent({
  components: {
    FormRegistro,
    DialogImportPersonalPolicial,
  },
  data(){
    const dialog_import = false;
    return {
      dialog_import,
    }
  },
  methods:{
    async openDialogImportData() {
      this.dialog_import = true;
    },
    closeDialogImportData() {
      this.dialog_import = false;
    },
  },
});

</script>